export enum PlanType {
  free = "フリー",
  starter = "スタンダード",
  premium = "プレミアム",
  enterprise = "エンタープライズ",
}
